import React from "react";
import { Box, Typography, Grid, TextField, MenuItem, Paper } from "@mui/material";
import { Controller } from "react-hook-form";
import { isMobile } from "react-device-detect";

const ElectricityComponent = ({
  propertyUsage,
  currentTypes,
  control,
  errors,
}) => {
  return (
    <>
      <Box
        sx={{
          background: "#fff",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1.5,
          px: 3,
          width: isMobile ? "100%" : 300,
          borderRadius: "8px",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
          استخدام العقار
        </Typography>
      </Box>
      <Paper
        elevation={1}
        sx={{ 
          p: 3, 
          borderRadius: "12px",
          border: "1px solid #e0e0e0"
        }}
      >
        <Grid spacing={3} container>
        <Grid item xs={12} md={4}>
          <Typography sx={{ fontWeight: "bold" }}>استخدام العقار</Typography>

          <Controller
            name="propertyUsage"
            control={control}
            defaultValue=""
            rules={{
              required: "هذا الحقل مطلوب",
            }}
            render={({ field }) => (
              <TextField
                {...field}
                select
                fullWidth
                variant="outlined"
                InputProps={{
                  placeholder: "",
                }}
                FormHelperTextProps={{
                  sx: {
                    textAlign: "start",
                  },
                }}
                error={!!errors.propertyUsage}
                helperText={
                  errors.propertyUsage ? errors.propertyUsage.message : ""
                }
              >
                {propertyUsage.map((option) => (
                  <MenuItem key={option.name} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography sx={{ fontWeight: "bold" }}>وصف العقار</Typography>
          <Controller
            name="propertyDescription"
            control={control}
            rules={{
              required: "هذا الحقل مطلوب",
            }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                multiline
                variant="outlined"
                InputProps={{
                  placeholder: "",
                }}
                FormHelperTextProps={{
                  sx: {
                    textAlign: "start",
                  },
                }}
                error={!!errors.propertyDescription}
                helperText={
                  errors.propertyDescription
                    ? errors.propertyDescription.message
                    : ""
                }
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography sx={{ fontWeight: "bold" }}>
            نوع التيار الكهربائي
          </Typography>

          <Controller
            name="currentType"
            control={control}
            defaultValue="" // Ensure default value is set
            rules={{
              required: "هذا الحقل مطلوب",
            }}
            render={({ field }) => (
              <TextField
                {...field}
                select
                fullWidth
                variant="outlined"
                InputProps={{
                  placeholder: "",
                }}
                FormHelperTextProps={{
                  sx: {
                    textAlign: "start",
                  },
                }}
                error={!!errors.currentType}
                helperText={
                  errors.currentType ? errors.currentType.message : ""
                }
              >
                {currentTypes.map((option) => (
                  <MenuItem key={option.name} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
      </Grid>
      </Paper>
    </>
  );
};

export default ElectricityComponent;
